/**
 * Created by lycheng on 2017/11/29.
 * 开通服务弹出层获取数据后的html拼接
 */
import { config } from 'config'
function getHtml (data, serviceConfig) {
  var html
  if (data) {
    data = data || []
    serviceConfig = serviceConfig || {}
    if (!data.length) {
      // 没有应用
      html = `<div class="service-open-item service-open-tip service-open-no-app">
      ${serviceConfig.noAppTip || '您还未创建应用，请先创建应用。'}
    </div>`
    } else {
      let unOpenAppsHtml = ''
      let unOpenHtml = ''
      let openedAppsHtml = ''
      let openedHtml = ''
      let allOpenedHtml = ''
      var defaultTipHtml = ''
      if (serviceConfig.defaultTip) {
        defaultTipHtml = `<div class="service-open-item service-open-tip service-open-default-tip">
      ${serviceConfig.defaultTip}
    </div>`
      }
      //  开通服务的apps
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          openedAppsHtml += `<li class="swiper-slide " 
data-app-id="${data[i].appId}"
data-app-name="${data[i].appName}"
title="${data[i].appName}">
              <i class="icons icons-app-default"></i>
              <span>${data[i].appName}</span>
            </li>`
        }
        openedHtml = `<div class="service-open-item service-open-opened">
        ${serviceConfig.openedTitle || serviceConfig.unOpenTitle ? `<div class="service-open-title">${serviceConfig.unOpenTitle || serviceConfig.openedTitle}</div>` : ''}
        <div class="service-open-apps service-opened-apps">
          <div class="swiper-container">
            <ul class="swiper-wrapper">
              ${openedAppsHtml}
            </ul>
            <div class="swiper-button-prev swiper-button"></div>
            <div class="swiper-button-next swiper-button"></div>
          </div>
        </div>
      </div>`
      }
      html = defaultTipHtml + allOpenedHtml + unOpenHtml + openedHtml + `<div class="modal-buttons">
      <a class="modal-button modal-button-ok">${serviceConfig.okButton || '确定'}</a>
      <a class="modal-button modal-button-cancle">取消</a>
    </div>
    `
    }
  } else {
    if (serviceConfig === 'loading') {
      html = `<div class="loader-wrap loader-ball-spin-fade">
  <div class="loader-inner">
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
    <i class="icons icons-loader"></i>
  </div>
</div>`
    } else {
      html = `<div class="service-open-item service-open-tip">
        数据获取失败
      </div>`
    }
  }
  return html
}
export {
  getHtml
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-services-open-html.js